import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPermissions } from "../../actions/userActions/permissionsAction";
import $ from "jquery";
import "./NewSidebar.css";
import agentSvg from "./../Agent/agent.svg";
import { Link } from "react-router-dom";
import {
    TaskExist,
    ManageExist,
    BillingExist,
    InvoiceExist,
} from "./menuArrays";
import { useLocation } from "react-router-dom";
import { logout } from "../../actions/auth/auth";
import SidebarIcons from "./SidebarIcons";
import { DOWNLOAD_APP_URL } from "../../Constatns";
import MenuItem from "./MenuItem";
import SubmenuItem from "./SubmenuItem";

function NewSidebar() {
    const dispatch = useDispatch();
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem("user"));
    const [localPermissions, setLocalPermissions] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isTaskDrawerOpen, setIsTaskDrawerOpen] = useState(false);
    const [isManageDrawerOpen, setIsManageDrawerOpen] = useState(false);
    const [isTaskSubitemSelected, setIsTaskSubitemSelected] = useState(false);
    const [isManageSubitemSelected, setIsManageSubitemSelected] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState(null);
    const element = document.querySelector('.page-wrapper');
    const taskDrawerRef = useRef(null); // Reference to the drawer
    const manageDrawerRef = useRef(null); // Reference to the drawer
    const taskDropdownRef = useRef(null);
    const manageDropdownRef = useRef(null);
    const dashboardDropdownRef = useRef(null);
    const formsDropdownRef = useRef(null);
    const logoutRef = useRef(null);

    const employeeId =
        user?.result[0] !== undefined ? user.result[0].user.id : false;
    const download_app = DOWNLOAD_APP_URL;
    const resetSidebarState = () => {
        setIsSidebarOpen(false);
        setIsTaskDrawerOpen(false);
        setIsManageDrawerOpen(false);
        setIsTaskSubitemSelected(false);
        setIsManageSubitemSelected(false);
        $(".page-wrapper").removeClass("toggled subitemclicked");
        $("body").removeClass("sidebar-open");
        $(".sidebar-wrapper").removeClass("toggled-sideBar");
    };
    useEffect(() => {
        !employeeId && dispatch(logout());

        $("body").on("click", "#close-sidebar", function () {
            let $pageWrapper = $(".page-wrapper");
            let $sidebarWrapper = $(".sidebar-wrapper");
            let $sidebarIcon = $(".sidebar-menu-title");

            if ($pageWrapper.hasClass("toggled")) {
               resetSidebarState();
            } else {
                $pageWrapper.addClass("toggled");
                $sidebarWrapper.addClass("toggled-sideBar");
                $("body").addClass("sidebar-open");
                setIsSidebarOpen(true);
            }
        });

        $("body").on("click", ".subitem", function () {
            let $pageWrapper = $(".page-wrapper");
            let $sidebarWrapper = $(".sidebar-wrapper");
            let $sidebarIcon = $(".sidebar-menu-title");

            if ($pageWrapper.hasClass("toggled")) {
                $pageWrapper.addClass("subitemclicked");
                $pageWrapper.removeClass("toggled");
                $("body").removeClass("sidebar-open");
                setIsSidebarOpen(false);
            }
        });


        $("body").on("click", ".item", function () {
            let $pageWrapper = $(".page-wrapper");
            let $sidebarWrapper = $(".sidebar-wrapper");
            let $sidebarIcon = $(".sidebar-menu-title");

            if ($pageWrapper.hasClass("subitemclicked")) {
                // $pageWrapper.removeClass("subitemclicked");
                $pageWrapper.addClass("toggled");
                $("body").addClass("sidebar-open");
                setIsSidebarOpen(true);
            } else {
                $pageWrapper.addClass("toggled");
                $("body").addClass("sidebar-open");
                setIsSidebarOpen(true);
            }
        });
        $("body").on("click", ".dashitem", function () {
            let $pageWrapper = $(".page-wrapper");
            let $sidebarWrapper = $(".sidebar-wrapper");
            let $sidebarIcon = $(".sidebar-menu-title");

            if ($pageWrapper.hasClass("subitemclicked")) {
                $pageWrapper.removeClass("subitemclicked");
                $pageWrapper.addClass("toggled");
                $("body").addClass("sidebar-open");
                setIsSidebarOpen(true);
            } else {
                $pageWrapper.addClass("toggled");
                $("body").addClass("sidebar-open");
                setIsSidebarOpen(true);
            }
        });
    }, []);

    useEffect(() => {
        const permissionsListString = localStorage.getItem("permissionsList");
        if (permissionsListString != null) {
            setLocalPermissions(JSON.parse(permissionsListString));
        }
    }, []);

    const permissions = useSelector(
        (state) => state.permissions_reducer.permissions
    );

    const handleDrawerListItemClick = () => {
        setIsSidebarOpen(false);
    };
    const handleDashboardClick = () => {
      setSelectedMenuItem('dashboard');
      setIsTaskDrawerOpen(false);
        setIsManageDrawerOpen(false);
        setIsSidebarOpen(true);
    };
    
    const handleFormsClick = () => {
     setSelectedMenuItem('forms');
         setIsTaskDrawerOpen(false);
        setIsManageDrawerOpen(false);
      setIsSidebarOpen(true);
    };
    const handleAgentsClick = () =>{
        setSelectedMenuItem('agent');
        setIsTaskDrawerOpen(false);
       setIsManageDrawerOpen(false);
     setIsSidebarOpen(true);
    }
    const handleTaskItemClick = () => {
       if (selectedMenuItem === 'manage') {
            setIsManageSubitemSelected(false);
        }
        
     setSelectedMenuItem('task');
       setIsManageDrawerOpen(false);
        setIsTaskDrawerOpen(true);
    };
    
    const handleManageItemClick = () => {
        if (selectedMenuItem === 'task') {
            setIsTaskSubitemSelected(false);
        }
       setSelectedMenuItem('manage');
        setIsTaskDrawerOpen(false);
        setIsManageDrawerOpen(true);
    };
    const path = (path) => {
        if (location.pathname === path) {
            return "active";
        }
    };
    const logoutHandle = async () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user && user?.result)
            dispatch(logout(user.result[0]?.user.id, ""));
    };
    const pathactive = (pathArray, menuType = null) => {
      if (menuType) {
           return selectedMenuItem === menuType ? "active" : "";
        }
     
        if (pathArray && pathArray.includes(location.pathname)) {
            return "active";
        }
        return "";
    };

    const taskurl = ["/admin/tasks", "/admin/AddTasks", "/admin/task/view", "/admin/locate", "/admin/TaskTarget", "/admin/completedtask", "/admin/Planner"];
    const manageUrl = [
        "/admin/visitProfiles", "/admin/AddVisitProfile", "/admin/UpdateVisitProfile", "/admin/ViewVisitProfile",
        "/admin/employees", "/admin/Addemployees", "/admin/UpdateEmployees", "/admin/ViewEmployees",
        "/admin/permission", "/admin/permissionGroup", "/admin/ViewPermissions", "/admin/AddPermissions", "/admin/UpdatePermissions",
        "/admin/officeLocations", "/admin/UpdateOfficeLocations", "/admin/AddOfficeLocations",
        "/admin/teams", "/admin/UpdateTeams", "/admin/AddTeams",
        "/admin/products", "/admin/UpdateProducts", "/admin/addProducts",
        "/admin/designations","/admin/designationLevel", "/admin/UpdateDesignations", "/admin/AddDesignations",
        "/admin/departments", "/admin/UpdateDepartments", "/admin/AddDepartments",
        "/admin/doctors", "/admin/UpdateDoctors", "/admin/AddDoctors",
        "/admin/doctorRanks", "/admin/UpdateDoctorRanks", "/admin/AddDoctorRanks",
        "/admin/doctorSpecializations", "/admin/UpdateDoctorSpecializations", "/admin/AddDoctorSpecializations",
        "/admin/practiceLocations", "/admin/UpdatePracticeLocations", "/admin/AddPracticeLocations",
        "/admin/locationTypes", "/admin/UpdateLocationTypes", "/admin/AddLocationTypes",
        "/admin/employmentStatuses", "/admin/UpdateEmploymentStatuses", "/admin/AddEmploymentStatuses",
        "/admin/CustomerRank", "/admin/UpdateCustomerRank", "/admin/AddCustomerRank",
        "/admin/subTasks", "/admin/UpdateSubTasks", "/admin/AddSubTasks",
        "/admin/taskStatuses", "/admin/taskTypes", "/admin/AddTaskTypes", "/admin/UpdateTaskTypes", "/admin/taskPriorities", "/admin/AddTaskPriorities", "/admin/UpdateTaskPriorities",
        "/admin/cities", "/admin/UpdateCities", "/admin/AddCities",
        "/admin/countries", "/admin/roles", "/admin/UpdateRoles", "/admin/AddRoles"
    ];

    //

    useEffect(() => {
        // Function to handle clicks outside the drawers
        const handleClickOutside = (event) => {
            const clickedOutsideTaskDrawer =
            taskDrawerRef.current &&
            !formsDropdownRef.current?.contains(event.target) &&
            !logoutRef.current?.contains(event.target) &&
            !dashboardDropdownRef.current?.contains(event.target) &&
            !taskDropdownRef.current?.contains(event.target) &&
            (!manageDropdownRef?.current || !manageDropdownRef.current?.contains(event.target)) &&
            !taskDrawerRef.current.contains(event.target);
        
        const clickedOutsideManageDrawer =
            manageDrawerRef.current &&
            !formsDropdownRef.current?.contains(event.target) &&
            !logoutRef.current?.contains(event.target) &&
            !dashboardDropdownRef.current?.contains(event.target) &&
            !manageDropdownRef.current?.contains(event.target) &&
            !taskDropdownRef.current?.contains(event.target) &&
            !manageDrawerRef.current.contains(event.target);
        

            if (clickedOutsideTaskDrawer && isTaskDrawerOpen && !isTaskSubitemSelected) {
                // Hide task drawer
                setIsTaskDrawerOpen(false);
            }

            if (clickedOutsideManageDrawer && isManageDrawerOpen && !isManageSubitemSelected) {
                // Hide manage drawer
                setIsManageDrawerOpen(false);
            }

            if (
                clickedOutsideManageDrawer &&
                isManageDrawerOpen &&
                isTaskSubitemSelected
            ) {
                // Hide manage drawer and show task drawer
                setIsTaskDrawerOpen(true);
                setIsManageDrawerOpen(false);
                if (element.classList.contains('toggled') && element.classList.contains('subitemclicked')) {
                    console.log("toggled");
                    element.classList.remove('toggled')
                    element.classList.remove('sidebar-open')
                    setIsSidebarOpen(false);

                }
            }

            if (
                clickedOutsideTaskDrawer &&
                isTaskDrawerOpen &&
                isManageSubitemSelected
            ) {
                // Hide task drawer and show manage drawer
                setIsManageDrawerOpen(true);
                setIsTaskDrawerOpen(false);
                if (element.classList.contains('toggled') && element.classList.contains('subitemclicked')) {
                    element.classList.remove('toggled')
                    element.classList.remove('sidebar-open')
                    setIsSidebarOpen(false);
                }
            }

            if (
                clickedOutsideTaskDrawer &&
                isTaskDrawerOpen &&
                isTaskSubitemSelected
            ) {
                if (element.classList.contains('toggled') && element.classList.contains('subitemclicked')) {
                    console.log("toggled");
                    element.classList.remove('toggled')
                    element.classList.remove('sidebar-open')
                    setIsSidebarOpen(false);

                }
            }
            if (
                clickedOutsideManageDrawer &&
                isManageDrawerOpen &&
                isManageSubitemSelected
            ) {
                if (element.classList.contains('toggled') && element.classList.contains('subitemclicked')) {
                    console.log("toggled");
                    element.classList.remove('toggled')
                    element.classList.remove('sidebar-open')
                    setIsSidebarOpen(false);

                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isTaskDrawerOpen,
        isManageDrawerOpen,
        isTaskSubitemSelected,
        isManageSubitemSelected,
    ]);
    useEffect(() => {
       if (taskurl.includes(location.pathname)) {
            setIsTaskSubitemSelected(true);
            setSelectedMenuItem('task');
        } else if (!taskurl.includes(location.pathname)) {
            setIsTaskSubitemSelected(false);
          if (selectedMenuItem === 'task') {
                setSelectedMenuItem(null);
            }
        }
    
      if (manageUrl.includes(location.pathname)) {
            setIsManageSubitemSelected(true);
            setSelectedMenuItem('manage');
        } else if (!manageUrl.includes(location.pathname)) {
            setIsManageSubitemSelected(false);
          if (selectedMenuItem === 'manage') {
                setSelectedMenuItem(null);
            }
        }
    
        if (location.pathname == "/admin/Profile") {
            if (element && element.classList.contains('subitemclicked')) {
                element.classList.remove('subitemclicked')
                setIsTaskDrawerOpen(false);
                setIsManageDrawerOpen(false);
                setSelectedMenuItem(null);
            }
        }
    }, [location.pathname]);
    return (
        <>
            <nav
                id="sidebar"
                className="sidebar-wrapper sidebar-border-class sidebar-shadow"

            >
                <div className="sidebar-content"
                    style={{ position: "relative", overflow: "visible" }}
                >
                    <div className="sidebar-menu">
                        <ul className="sidebar-menu-list">
                            <li className={`align-items-center gap-3 ${path("/admin")}`}>
                                <div className="align-items-center">
                                    <div id="close-sidebar" style={{ paddingTop: "24px", position: "absolute", top: "-16px", right: "-18px", zIndex: "999" }}>
                                        <i
                                            style={{
                                                paddingLeft: "15px",
                                                paddingTop: "24px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <img
                                                src={
                                                    isSidebarOpen
                                                        ? SidebarIcons.SidebarIcon
                                                        : SidebarIcons.CloseSidebar
                                                }
                                            />
                                        </i>
                                    </div>

                                </div>
                            </li>
                          
                    <li
                        ref={dashboardDropdownRef}
                        className={`dashboard-dropdown task-dropdown ${isSidebarOpen ? "" : "no-arrow"}`}
                        onClick={handleDashboardClick}
                    >
                        <MenuItem
                            icon={SidebarIcons.dashboardIcon}
                            text="Dashboard"
                            to="/admin"
                            className={`${pathactive(null, 'dashboard')} dashitem`}
                            isSidebarOpen={isSidebarOpen}
                            hasArrow={false}
                        />
                    </li>


                {((permissions && permissions.includes('CanViewTask')) || (localPermissions.includes('CanViewTask'))) && (
                    <li
                        ref={taskDropdownRef}
                        className={`dashboard-dropdown task-dropdown ${isSidebarOpen ? "" : "no-arrow"}`}
                    >
                        <MenuItem
                            icon={SidebarIcons.taskIcon}
                            text="Task"
                            onClick={handleTaskItemClick}
                            className={`sidebar-dropdown ${pathactive(taskurl, 'task')} item`}
                            isSidebarOpen={isSidebarOpen}
                            hasArrow={true}
                            to="#"
                        />
                    </li>
                )}

                {((permissions && permissions.includes('CanViewManage')) || (localPermissions.includes('CanViewManage'))) && (
                    <li
                        ref={manageDropdownRef}
                        className={`dashboard-dropdown task-dropdown ${isSidebarOpen ? "" : "no-arrow"}`}
                    >
                        <MenuItem
                            icon={SidebarIcons.manageIcon}
                            text="Manage"
                            onClick={handleManageItemClick}
                            className={`sidebar-dropdown ${pathactive(manageUrl, 'manage')} item`}
                            isSidebarOpen={isSidebarOpen}
                            hasArrow={true}
                            to="#"
                        />
                    </li>
                )}

                <li
                    ref={formsDropdownRef}
                    className={`dashboard-dropdown task-dropdown ${isSidebarOpen ? "" : "no-arrow"}`}
                    onClick={handleFormsClick}
                >
                    <MenuItem
                        icon={SidebarIcons.Forms_icon}
                        text="Forms"
                        to="/admin/forms"
                        className={`${pathactive(null, 'forms')} dashitem`}
                        isSidebarOpen={isSidebarOpen}
                        hasArrow={false}
                    />
                </li>
                            <li
                                ref={formsDropdownRef}
                                className={`dashboard-dropdown task-dropdown ${isSidebarOpen ? "" : "no-arrow"
                                    }`}
                                onClick={handleAgentsClick}
                            >
                                <MenuItem
                                icon={agentSvg}
                                    text="Agent"
                                    to="/admin/agent"
                                    className={path("/admin/agent") + " dashitem"}
                                    isSidebarOpen={isSidebarOpen}
                                    hasArrow={false}
                                />
                            </li>
                            {/* form section End  */}
                        </ul>
                        <ul
                            ref={logoutRef}
                            className="logout-menu pr-3">
                            {/* {isSidebarOpen && (
                                <div className="download_app">
                                    <button onClick={() => (window.location.href = download_app)}>
                                        <img
                                            src={SidebarIcons.download_app}
                                            width={30}
                                            height={20}
                                            alt=""
                                        />
                                        Download Android App
                                    </button>
                                </div>
                            )} */}
                            <hr></hr>
                            <li
                                className="logout-item py-2 pr-2"
                                onClick={logoutHandle}>
                                <MenuItem
                                    icon={SidebarIcons.logoutIcon}
                                    text="Logout"
                                    className="logout-link"
                                    isSidebarOpen={isSidebarOpen}
                                    hasArrow={false}
                                    to="/logout"
                                />
                            </li>
                        </ul>
                    </div>

                </div>
            </nav>

            {isTaskDrawerOpen && (
                <div
                    className="task-drawer task-drawer-wrapper"
                    ref={taskDrawerRef} // Reference the drawer element
                    style={{
                        width: "250px",
                        position: "absolute",
                        left: isSidebarOpen ? "260px" : "75px",
                        padding: "10px",
                    }}
                >
                    <div className="drawer-heading">
                        Task
                    </div>
                    <ul className="task-ul task-dropdown">
                        {(permissions.includes("CanViewTask") || localPermissions.includes("CanViewTask")) && (
                            <SubmenuItem
                                icon={SidebarIcons.taskQueueIcon}
                                text="Task List"
                                to="/admin/tasks"
                                className={`${path("/admin/tasks") === "active" || path("/admin/AddTasks") || path("/admin/task/view") === "active" ? "active" : ""} subitem`}
                                onClick={handleDrawerListItemClick}
                            />
                        )}
                        {(permissions.includes("CanViewPlan") || localPermissions.includes("CanViewPlan")) && (
                            <SubmenuItem
                                icon={SidebarIcons.plannerIcon}
                                text="Planner"
                                to="/admin/Planner"
                                className={path("/admin/Planner") + " subitem"}
                                onClick={handleDrawerListItemClick}
                            />
                        )}

                        {(permissions.includes("CanLocateSubOrdinate") || localPermissions.includes("CanLocateSubOrdinate")) && (
                            <SubmenuItem

                                icon={SidebarIcons.locateIcon}
                                text="Locate"
                                to="/admin/locate"
                                className={path("/admin/locate") + " subitem"}
                                onClick={handleDrawerListItemClick}
                            />
                        )}

                        {(permissions.includes("CanViewTaskTarget") || localPermissions.includes("CanViewTaskTarget")) && (
                            <SubmenuItem
                                icon={SidebarIcons.taskTargetIcon}
                                text="Task Target"
                                to="/admin/TaskTarget"
                                className={path("/admin/TaskTarget") + " subitem"}
                                onClick={handleDrawerListItemClick}
                            />
                        )}

                        {(permissions.includes("CanViewArchivedTask") || localPermissions.includes("CanViewArchivedTask")) && (
                            <SubmenuItem
                                icon={SidebarIcons.archiveTask}
                                text="Archive Task"
                                to="/admin/completedtask"
                                className={path("/admin/completedtask") + " subitem"}
                                onClick={handleDrawerListItemClick}
                            />
                        )}
                    </ul>
                </div>
            )}

            {isManageDrawerOpen && (
                <div
                    className="manage-drawer manage-drawer-wrapper"
                    ref={manageDrawerRef} // Reference the drawer element
                    style={{
                        width: "250px",
                        position: "absolute",
                        left: isSidebarOpen ? "260px" : "75px",
                        padding: "10px",
                        margin: 0,
                        overflowY: "scroll",
                        overflowX: "hidden",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                    }}
                >
                    <div className="drawer-heading">
                        Manage
                    </div>
                    <ul className="manage-dropdown">
                        {(permissions.includes("CanViewVisitProfile") ||
                            localPermissions.includes("CanViewVisitProfile")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.visitProfileIcon}
                                    text="Visit Profile"
                                    to="/admin/visitProfiles"
                                    className={`${path("/admin/visitProfiles") === "active" || path("/admin/AddVisitProfile") === "active" || path("/admin/UpdateVisitProfile") === "active" || path("/admin/ViewVisitProfile") === "active" ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />

                            )}
                        {(permissions.includes("CanViewEmployee") ||
                            localPermissions.includes("CanViewEmployee")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.employeesIcon}
                                    text="Employee"
                                    to="/admin/employees"
                                    className={`${path("/admin/employees") === "active" || path("/admin/Addemployees") === "active" || path("/admin/UpdateEmployees") === "active" || path("/admin/ViewEmployees") === "active" ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />

                            )}
                        {(permissions.includes("CanViewPermission") ||
                            localPermissions.includes("CanViewPermission")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.permissionIcon}
                                    text="Permission Group"
                                    to="/admin/permissionGroup"
                                    className={`${path("/admin/permissionGroup") === "active" ||
                                        path("/admin/ViewPermissions") === "active" ||
                                        path("/admin/AddPermissions") === "active" ||
                                        path("/admin/UpdatePermissions") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                              {(permissions.includes("CanViewPermission") ||
                            localPermissions.includes("CanViewPermission")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.permissionIcon}
                                    text="Permissions"
                                    to="/admin/permission"
                                    className={`${path("/admin/permission") === "active" ||
                                        path("/admin/ViewPermission") === "active" 
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewOfficeLocation") ||
                            localPermissions.includes("CanViewOfficeLocation")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.officeLocationIcon}
                                    text="Office Location"
                                    to="/admin/officeLocations"
                                    className={`${path("/admin/officeLocations") === "active" ||
                                        path("/admin/UpdateOfficeLocations") === "active" ||
                                        path("/admin/AddOfficeLocations") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewTeam") ||
                            localPermissions.includes("CanViewTeam")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.teamIcon}
                                    text="Team"
                                    to="/admin/teams"
                                    className={`${path("/admin/teams") === "active" ||
                                        path("/admin/UpdateTeams") === "active" ||
                                        path("/admin/AddTeams") === "active"
                                        ? "active" : ""} subitem`}

                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewProduct") ||
                            localPermissions.includes("CanViewProduct")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.productIcon}
                                    text="Product"
                                    to="/admin/products"
                                    className={`${path("/admin/products") === "active" ||
                                        path("/admin/UpdateProducts") === "active" ||
                                        path("/admin/addProducts") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewDesignation") ||
                            localPermissions.includes("CanViewDesignation")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.designationIcon}
                                    text="Designation"
                                    to="/admin/designations"
                                    className={`${path("/admin/designations") === "active" ||
                                        path("/admin/UpdateDesignations") === "active" ||
                                        path("/admin/AddDesignations") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                              {(permissions.includes("CanViewDesignationLevel") ||
                            localPermissions.includes("CanViewDesignationLevel")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.designationLevelIcon}
                                    text="Designation Level"
                                    to="/admin/designationLevel"
                                    className={`${path("/admin/designationLevel") === "active" 
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewDepartment") ||
                            localPermissions.includes("CanViewDepartment")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.departmentIcon}
                                    text="Department"
                                    to="/admin/departments"
                                    className={`${path("/admin/departments") === "active" ||
                                        path("/admin/UpdateDepartments") === "active" ||
                                        path("/admin/AddDepartments") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewDoctor") ||
                            localPermissions.includes("CanViewDoctor")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.doctorIcon}
                                    text="Doctor"
                                    to="/admin/doctors"
                                    className={`${path("/admin/doctors") === "active" ||
                                        path("/admin/UpdateDoctors") === "active" ||
                                        path("/admin/AddDoctors") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewDoctorRank") ||
                            localPermissions.includes("CanViewDoctorRank")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.doctorRankIcon}
                                    text="Doctor Designation"
                                    to="/admin/doctorRanks"
                                    className={`${path("/admin/doctorRanks") === "active" ||
                                        path("/admin/UpdateDoctorRanks") === "active" ||
                                        path("/admin/AddDoctorRanks") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewDoctorSpecialization") ||
                            localPermissions.includes(
                                "CanViewDoctorSpecialization"
                            )) && (
                                <SubmenuItem
                                    icon={SidebarIcons.doctorSpecializationIcon}
                                    text="Doctor Specialization"
                                    to="/admin/doctorSpecializations"
                                    className={`${path("/admin/doctorSpecializations") === "active" ||
                                        path("/admin/UpdateDoctorSpecializations") === "active" ||
                                        path("/admin/AddDoctorSpecializations") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewPracticeLocation") ||
                            localPermissions.includes(
                                "CanViewPracticeLocation"
                            )) && (
                                <SubmenuItem
                                    icon={SidebarIcons.practiceLocationIcon}
                                    text="Practice Location"
                                    to="/admin/practiceLocations"
                                    className={`${path("/admin/practiceLocations") === "active" ||
                                        path("/admin/UpdatePracticeLocations") === "active" ||
                                        path("/admin/AddPracticeLocations") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewPracticeLocationType") ||
                            localPermissions.includes(
                                "CanViewPracticeLocationType"
                            )) && (
                                <SubmenuItem
                                    icon={SidebarIcons.practiceLocationTypeIcon}
                                    text="Practice Location Type"
                                    to="/admin/locationTypes"
                                    className={`${path("/admin/locationTypes") === "active" ||
                                        path("/admin/UpdateLocationTypes") === "active" ||
                                        path("/admin/AddLocationTypes") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewEmploymentStatus") ||
                            localPermissions.includes(
                                "CanViewEmploymentStatus"
                            )) && (
                                <SubmenuItem
                                    icon={SidebarIcons.employeeStatusIcon}
                                    text="Employment Status"
                                    to="/admin/employmentStatuses"
                                    className={`${path("/admin/employmentStatuses") === "active" ||
                                        path("/admin/UpdateEmploymentStatuses") === "active" ||
                                        path("/admin/AddEmploymentStatuses") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}

                        {(permissions.includes("CanViewCustomerRank") ||
                            localPermissions.includes("CanViewCustomerRank")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.CustomerRank}
                                    text="Customer Rank"
                                    to="/admin/CustomerRank"
                                    className={`${path("/admin/CustomerRank") === "active" ||
                                        path("/admin/UpdateCustomerRank") === "active" ||
                                        path("/admin/AddCustomerRank") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}

                        {(permissions.includes("CanViewSubTask") ||
                            localPermissions.includes("CanViewSubTask")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.subTasksIcon}
                                    text="Sub Task"
                                    to="/admin/subTasks"
                                    className={`${path("/admin/subTasks") === "active" ||
                                        path("/admin/UpdateSubTasks") === "active" ||
                                        path("/admin/AddSubTasks") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewTaskStatus") ||
                            localPermissions.includes("CanViewTaskStatus")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.taskStatusIcon}
                                    text="Task Status"
                                    to="/admin/taskStatuses"
                                    className={path("/admin/taskStatuses") + " subitem"}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewTaskType") ||
                            localPermissions.includes("CanViewTaskType")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.taskTypeIcon}
                                    text="Task Type"
                                    to="/admin/taskTypes"
                                    // className={path("/admin/taskTypes") + " subitem"}
                                    className={`${path("/admin/taskTypes") === "active" ||
                                        path("/admin/AddTaskTypes") === "active" ||
                                        path("/admin/UpdateTaskTypes") === "active"
                                        ? "active" : ""} subitem`}

                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewTaskPriority") ||
                            localPermissions.includes("CanViewTaskPriority")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.taskPriorityIcon}
                                    text="Task Priority"
                                    to="/admin/taskPriorities"
                                    className={`${path("/admin/taskPriorities") === "active" ||
                                        path("/admin/UpdateTaskPriorities") === "active" ||
                                        path("/admin/AddTaskPriorities") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}

                        {(permissions.includes("CanViewCity") ||
                            localPermissions.includes("CanViewCity")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.cityIcon}
                                    text="City"
                                    to="/admin/cities"
                                    className={`${path("/admin/cities") === "active" ||
                                        path("/admin/UpdateCities") === "active" ||
                                        path("/admin/AddCities") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewCountry") ||
                            localPermissions.includes("CanViewCountry")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.countryIcon}
                                    text="Country"
                                    to="/admin/countries"
                                    className={path("/admin/countries") + " subitem"}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                        {(permissions.includes("CanViewRole") ||
                            localPermissions.includes("CanViewRole")) && (
                                <SubmenuItem
                                    icon={SidebarIcons.rolesIcon}
                                    text="Role"
                                    to="/admin/roles"
                                    className={`${path("/admin/roles") === "active" ||
                                        path("/admin/UpdateRoles") === "active" ||
                                        path("/admin/AddRoles") === "active"
                                        ? "active" : ""} subitem`}
                                    onClick={handleDrawerListItemClick}
                                />
                            )}
                    </ul>
                </div>
            )}
        </>
    );
}

export default NewSidebar;
